import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import useIntersectionObserver from '../../../hooks/common/useIntersectionObserver';

const SSRAwareLazyLoad = forwardRef(({
  children,
  offset = 0,
  height,
  once = true,
  threshold = 0,
  placeholder = null,
  ...otherProps
}, forwardedRef) => {
  const { elementRef, hasIntersected } = useIntersectionObserver({
    rootMargin: `${offset}px`,
    threshold,
    once,
  });

  if (window.isSSR) return children;

  const containerStyle = {
    minHeight: height,
    ...otherProps.style,
  };

  // Merge the intersection observer ref with any forwarded ref
  const handleRef = (node) => {
    // Set the intersection observer ref
    elementRef.current = node;

    // Also set the forwarded ref if provided
    if (forwardedRef) {
      if (typeof forwardedRef === 'function') {
        forwardedRef(node);
      } else {
        forwardedRef.current = node;
      }
    }
  };

  return (
    <div
      ref={handleRef}
      style={containerStyle}
      {...otherProps}
    >
      {hasIntersected ? children : placeholder}
    </div>
  );
});

SSRAwareLazyLoad.propTypes = {
  children: PropTypes.node.isRequired,
  offset: PropTypes.number,
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  once: PropTypes.bool,
  threshold: PropTypes.number,
  placeholder: PropTypes.node,
  className: PropTypes.string,
  style: PropTypes.object,
};

SSRAwareLazyLoad.defaultProps = {
  offset: 0,
  once: true,
  threshold: 0,
  placeholder: null,
};


export default SSRAwareLazyLoad;
